import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { SelectAccountsPage } from 'src/app/shared/modals/select-accounts/select-accounts.page';
import { CloseOverlayService } from 'src/app/shared/_services/closeOverlay.service';
import { DashboardStore } from 'src/app/shared/_services/store';
import { UpgradeStore } from 'src/app/shared/_services/store/upgradeStore.service';

@Component({
  selector: 'app-upgrade-account',
  templateUrl: './upgrade-account.page.html',
  styleUrls: ['./upgrade-account.page.scss'],
})
export class UpgradeAccountPage implements OnInit {
  tiers = [
    {
      tier: 'Gold',
      limitText: 'Daily withdrawal limit',
      limitAmount: '₦300,000',
      depositText: 'Maximum daily deposit',
      depositAmount: '₦500,000',
      pending: false,
      inProgress: false,
      declined: false,
      approved: false,
    },
    {
      tier: 'Platinum',
      limitText: 'Daily withdrawal limit',
      limitAmount: '₦500,000',
      depositText: 'Maximum daily deposit',
      depositAmount: 'Unlimited',
      pending: false,
      inProgress: false,
      declined: false,
      approved: false,
    },
  ];

  constructor(
    private router: Router,
    private upgradeStore: UpgradeStore,
    private dashboardStore: DashboardStore,
    private modalController: ModalController,
    private closeOverlayService: CloseOverlayService
  ) {}

  upgrade(tier: any) {
    if (tier.tier === 'Gold') {
      this.router.navigateByUrl('upgrade-account/gold');
    } else if (tier.tier === 'Platinum') {
      this.router.navigateByUrl('upgrade-account/platinum');
    }
  }

  async selectAccounts() {
    const modal = await this.modalController.create({
      component: SelectAccountsPage,
      backdropDismiss: true,
      showBackdrop: true,
      swipeToClose: true,
      // mode: 'ios',
      cssClass: 'select-account',
    });
    return await modal.present();
  }

  goBack() {
    this.router.navigateByUrl('/profile');
  }

  ionViewWillEnter() {
    this.upgradeStore.setIsStatusOk(true);
    this.upgradeStore.getAccountDocumentStatus().forEach((element) => {
      this.tiers.forEach((tier) => {
        if (element.Category !== null) {
          if (
            (element.Category.includes('INDIVIDUAL') ||
              element.Category.includes('BUSINESS')) &&
            tier.tier === 'Gold'
          ) {
            if (element.Status === 'Pending') {
              tier.pending = true;
            }
            if (element.Status === 'In Progress') {
              tier.inProgress = true;
            }
            if (element.Status === 'Declined') {
              tier.declined = true;
            }
            if (element.Status === 'Approved') {
              tier.approved = true;
            }
          }
          if (element.Category.includes('3') && tier.tier === 'Platinum') {
            if (element.Status === 'Pending') {
              tier.pending = true;
            }
            if (element.Status === 'In Progress') {
              tier.inProgress = true;
            }
            if (element.Status === 'Declined') {
              tier.declined = true;
            }
            if (element.Status === 'Approved') {
              tier.approved = true;
            }
          }
        }
      });
    });
    if (location.search.includes('select=true')) {
      this.selectAccounts();
    }
  }

  ngOnInit() {
    window.onpopstate = () => {
      this.closeOverlayService.trigger();
    };
  }
}
